export * from "./ambulance-side-view";
export { ReactComponent as Logo } from "./logo.svg";
export { ReactComponent as HorizontalLogo } from "./logo-horizontal.svg";
export * from "./palette";
export * from "./theme";

export const drawerWidth = 400;
export const narrowDrawerWidth = 240;
export const wideDrawerWidth = 595;
